// Deliverable / project status — mirrors the backend ProjectEntityStatus
// (openwrench-app app/models/workorder/Project.scala): 3 values, snake_case.
// This is the entity's own status; it is distinct from the work-order buckets
// (workOrderMetrics), which count linked work orders by WO status.
export const DELIVERABLE_STATUSES = {
	notStarted: 'not_started',
	inProgress: 'in_progress',
	completed: 'completed',
};

export const DELIVERABLE_STATUS_DISPLAY_NAMES = {
	[DELIVERABLE_STATUSES.notStarted]: 'Not Started',
	[DELIVERABLE_STATUSES.inProgress]: 'In Progress',
	[DELIVERABLE_STATUSES.completed]: 'Completed',
};

// Colors per Figma (12486-84576 / 84541 / 85019).
export const DELIVERABLE_STATUS_DISPLAY_TEXT_COLORS = {
	[DELIVERABLE_STATUSES.notStarted]: '#8c8c8c', // Grey/7
	[DELIVERABLE_STATUSES.inProgress]: '#657200',
	[DELIVERABLE_STATUSES.completed]: '#237804', // Polar Green/8
};

export const DELIVERABLE_STATUS_DISPLAY_BACKGROUND_COLORS = {
	[DELIVERABLE_STATUSES.notStarted]: '#f5f5f5', // Grey/3
	[DELIVERABLE_STATUSES.inProgress]: 'rgba(223,250,20,0.2)',
	[DELIVERABLE_STATUSES.completed]: '#d9f7be', // Polar Green/2
};

export const DELIVERABLE_STATUS_OPTIONS = [
	DELIVERABLE_STATUSES.notStarted,
	DELIVERABLE_STATUSES.inProgress,
	DELIVERABLE_STATUSES.completed,
];
